import styled from 'styled-components';

export const TitleContainer = styled.div`
  flex: 0 0 100%; /* flex-grow, flex-shrink, flex-basis */
  font-weight: 600;
  margin-bottom: 10px;
`;
